import { render, staticRenderFns } from "./HistoryInfoBoxes.vue?vue&type=template&id=4db7872f&scoped=true&"
import script from "./HistoryInfoBoxes.vue?vue&type=script&lang=js&"
export * from "./HistoryInfoBoxes.vue?vue&type=script&lang=js&"
import style0 from "./HistoryInfoBoxes.vue?vue&type=style&index=0&id=4db7872f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7872f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
